import { render } from "./acousticwave.vue?vue&type=template&id=1288c3d4&scoped=true"
const script = {}

import "./acousticwave.vue?vue&type=style&index=0&id=1288c3d4&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1288c3d4"]])

export default __exports__